import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { useState } from 'react';

import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { useNavigate } from 'react-router-dom';

import Field from '../../../utils/FormikFields/Field';

import { Button, Grid, CardContent, Card as MuiCard, CardHeader, CardMedia } from '@mui/material';

import OutboxRoundedIcon from '@mui/icons-material/OutboxRounded';
import LoginRoundedIcon from '@mui/icons-material/LoginRounded';
import PhoneAndroidRoundedIcon from '@mui/icons-material/PhoneAndroidRounded';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import HourglassBottomRoundedIcon from '@mui/icons-material/HourglassBottomRounded';

import Logo from "../../../images/logo.png";

// import CustomButton from "./Button";

import Dialog from '../../../utils/utilities/Dialog';

import { BasicFlex, InputLabel } from '../../../utils/Common';

import AutoCompleteSolo from '../../../utils/FormikFields/AutoCompleteSolo';

import { formatPhoneNumber } from '../../../utils/util';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { linkVendor } from '../apiService';

import useSnackbarStore from '../../../store/snackbar';

import { useDialogForm } from '../../../contexts/DialogForm';

const Card = styled.div`
  padding: 3px;
  height: 37rem;
  width: 27rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* align-items: center; */
  background-color: ${props => props.theme.colors.softBg};
  border-radius: 5px;
  box-shadow: ${props => props.theme.shadows[3]};

  @media ${props => props.theme.breaks.down('md')} {
    width: 100%;
  }
`;

const CustomButton = styled(Button)`
  font-weight: 400;
`;

const CoverLogo = styled.div`
  height: 10rem;
  background-color: #FAFBFF;
  width: 100%;
  padding: .5rem 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const CardInfo = styled(BasicFlex)`
  flex: 1;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  & > div {
    width: 100%;
  }
`;

const VendorInfo = styled(BasicFlex)`
  flex-direction: column;
  align-items: flex-start;
`;

const VendorName = styled.div`
  font-weight: bold;
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
`;

const VendorInfoLineStyles = styled.div`
  color: ${props => props.theme.colors.mildText};
  font-weight: 500;
  font-style: italic;
`

/* Vendor Display */

const VendorDisplayCard = styled(MuiCard)`
  width: 100%;
`

const VendorDisplayCardName = styled.div`
  font-weight: 500;
  font-size: 1.8rem;
  margin: .5rem .2rem;
  margin-bottom: .8rem;
`

const RequestAccessDialog = ({vendor = {}}) => {

  const { name, address, city, state, zip, phone, email } = vendor

  const showSnackbar = useSnackbarStore(state => state.showSnackbar);

  const queryClient = useQueryClient();

  const { handleClose } = useDialogForm() || {};

  const { mutate } = useMutation({
    mutationFn: linkVendor,
    onSuccess: () => {
      showSnackbar("Successfully requested access", "success");
      queryClient.invalidateQueries({ queryKey: ['portal']});
      if (handleClose) handleClose();
    },
    onError: () => {
      showSnackbar("Failed to request access", "error");
    }
  })

  const handleSubmit = (userInfo) => {
    let packet = {...vendor, ...userInfo};
    console.log(packet, "packet");
    mutate({ packet });
  }

  return (
    <Dialog 
     title="Request Access"
     toggle={<CustomButton startIcon={<OutboxRoundedIcon />} size="large" color="tertiary" variant="outlined" fullWidth>Request Access</CustomButton>} 
     saveText="Request Access"
     useForm={true}
     >
      <CardContent>
        <VendorDisplayCard elevation={3} sx={{display: "flex", mb: "2rem"}}>
          {/* <CardHeader subheader={name} sx={{p: 1}} /> */}
          
          <CardMedia
            image={Logo}
            sx={{width: "20rem", height: "14rem", objectFit: "contain"}}
          />
          <CardContent sx={{py: 0, pb: '0 !important', ml: '1rem'}}>
            <VendorInfo>
              <VendorDisplayCardName>{name}</VendorDisplayCardName>
              {address ? <VendorInfoLine info={`${address}, ${city}, ${state} ${zip}`} Icon={PlaceRoundedIcon} /> : null}
              {email ? <VendorInfoLine info={email} Icon={EmailRoundedIcon} /> : null}
              {phone ? <VendorInfoLine info={formatPhoneNumber(phone)} Icon={PhoneAndroidRoundedIcon} /> : null}
            </VendorInfo>
          </CardContent>

        </VendorDisplayCard>
        <Formik
          initialValues={{
            vendor_id: "",
            create_vendor: false,
          }}
          onSubmit={handleSubmit}
        >
          {({ values }) => (
            <Form>
              <Grid container spacing={2}>
                <Grid size={{xs: 12}}>
                  <Field
                    formFieldType="switch"
                    name="create_vendor"
                    label="Create Vendor"
                    type="checkbox"
                  />
                </Grid>
                <Grid size={{xs: 12}}>
                  <InputLabel>Link Vendor Account</InputLabel>
                 <AutoCompleteSolo
                    name="vendor_id"
                    placeholder="Select Vendor"
                    url="vendors"
                    fieldName="vendor_id"
                    displayField="full_name"
                    disabled={values.create_vendor}
                  />
                </Grid>
                <Grid size={{xs: 12}}>
                  <Button type="submit" size="large" color="secondary" variant="contained" fullWidth>Request Access</Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </CardContent>
    </Dialog>
  )

}

const VendorInfoLine = ({info, Icon}) => {
  return (
    <BasicFlex justify="flex-start" align="flex-start" gap="1rem" my=".5rem">
      {Icon ? <div><Icon color="basic" fontSize="small" /></div> : null}
      <VendorInfoLineStyles>{info}</VendorInfoLineStyles>
    </BasicFlex>
  )
}

const VendorCard = ({ vendor = {} }) => {
  const  navigate  = useNavigate();
  const viewVendor = () => {
    navigate(`/vendor-portal/view/${vendor.vendor_id}`);
  }
  const { logo, name, address, city, state, zip, phone, email, requestStatus, viewAccess, requestAccess, status } = vendor;
  return (
    <Card>
      <CoverLogo>
        <img src={logo} />
      </CoverLogo>
      <CardInfo>
        <VendorInfo>
          <VendorName>{name}</VendorName>
          {address ? <VendorInfoLine info={<div>{address} <br /> {city}, {state} {zip}</div>} Icon={PlaceRoundedIcon} /> : null}
          {phone ? <VendorInfoLine info={formatPhoneNumber(phone)} Icon={PhoneAndroidRoundedIcon} /> : null}
          {email ? <VendorInfoLine info={email} Icon={EmailRoundedIcon} /> : null}
        </VendorInfo>
        {status ? status === "accepted" ? (<CustomButton startIcon={<LoginRoundedIcon />} color="tertiary" variant="contained" fullWidth size="large" onClick={viewVendor} >View Account</CustomButton>) : (<CustomButton disabled startIcon={<HourglassBottomRoundedIcon />} color="tertiary" variant="outlined" fullWidth size="large" >Pending Approval</CustomButton>) : (<RequestAccessDialog vendor={vendor} />)}
      </CardInfo>
    </Card>
  );
}

export default VendorCard;